import React from "react";
import { NoDataAvailableDiv } from "../../components/NoDataAvailableDiv";
import FreefieldCategories from "./FreefieldCategories";
import { type FFPermissionMap } from "./PermissionMap";

interface Props {
  freeFields: server.dto.FreeFieldCategorySmall[]
  profile: server.dto.FreeFieldProfile
  permissions: FFPermissionMap
  onPermissionsChange: (permissions: FFPermissionMap) => void
}

const FreeFieldsSelectStep = (props: Props) => {
  if (props.freeFields.length === 0) {
    return (<NoDataAvailableDiv />);
  }

  return (
    <div>
      <FreefieldCategories
        profileId={props.profile.freeFieldProfileId}
        onPermissionsChange={props.onPermissionsChange}
        permissions={props.permissions}
        categories={props.freeFields}
        environment={props.profile.environment}
      />
    </div>
  );
};

export default FreeFieldsSelectStep;
